<div class="close-btn-div" [dir]="this.lang.getPageDirection()"> 
    <div class="close-btn" (click)="closeDialog()">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" class="bi bi-x" viewBox="0 0 30 30">
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
      </svg>
    </div>
  </div>
<div class="m-box" [dir]="this.lang.getPageDirection()">
    <h2>{{'messages.table.buttons.send_new_msg' | translate}}</h2>
    <div class="t-popup-close"></div>
    <div class="patient-info">
        <div class="patient-row">
            <div class="patient-detail firstname"> <span class="label">{{ "appointments.gui.labels.Name" | translate }}:</span> {{this.patient.First}} {{this.patient.Last}}</div>
        </div>
        <div class="patient-row">
            <div class="patient-detail id">
                <span class="label">{{
                    patient.IsID === 1
                      ? ("appointments.gui.labels.ID" | translate) + ":"
                      : ("appointments.gui.labels.Passport" | translate) + ":"
                  }}</span> {{this.patient.ID}}
              </div>&nbsp;
              <span><b>{{ "appointments.gui.labels.Mobile" | translate }}:</b> {{ this.patient.Mobile }} </span>
        </div>
     </div>
     <br>
     <div class="message-sent-container patient-info" [dir]="this.lang.getPageDirection()">
        <div class="patient-row">
        {{patient.First}} {{patient.Last}} {{GeneralMsgTemplateHeader}} 
        </div>
        <div class="m-box patient-row">
        <textarea #message class="t-field-text" placeholder="{{'messages.table.labels.msg_content' | translate}}" cols="3" rows="3"></textarea>
        </div>
        <div class="patient-row">
        {{GeneralMsgTemplateFooter}}
        </div>
        <footer *ngIf="message.value">
            <button (click)="sendWhatsapp(message.value)" class="orange-btn">{{'messages.table.buttons.send' | translate}}</button>
        </footer>
     </div>
</div>